import { useMutation } from '@tanstack/react-query';
import { useShowErrorToast } from '@utils/formHelpers';
import { queryFetch } from '@services/api';
import { useJobRefetch } from '@hooks/job/refetch';
import { DefaultApiResp } from '@root/globalTypes';
import { DestroyStageReq } from './types';

export const useRemoveStage = () => {
  const { refetch, job } = useJobRefetch();
  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ jobId, id }: DestroyStageReq): Promise<DefaultApiResp> =>
      queryFetch({
        url: `jobs/${jobId}/stages/${id}`,
        opt: { method: 'DELETE' },
      }),
    onMutate: async ({ jobId, id }) =>
      job.update({
        jobId,
        data: {
          stages: job.get(jobId)?.stages?.filter((stage) => stage.id !== id),
        },
      }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data, _error, { jobId }, prev) => {
      if (!data) return;
      const { errors } = data as DefaultApiResp;
      if (errors) {
        job.restore(jobId, prev);
        showErrorToast(errors);
      }
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
